'use strict';

var RomSummaryTopOppController = function RomSummaryTopOppController(SearchCriteriaRuleFactory, momentService, romSummaryTopOppGridService, featureToggleService, $scope, $state, $filter, transitionSearchCriteriaService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  $scope.topOppList = [{
    label: '10',
    value: '10'
  }, {
    label: '20',
    value: '20'
  }, {
    label: '30',
    value: '30'
  }, {
    label: '40',
    value: '40'
  }, {
    label: '50',
    value: '50'
  }, {
    label: 'Show all',
    value: 'all'
  }];
  $scope.setDefaultState = function () {
    var defaultIndex = 0;
    $scope.topOppRowsToDisplay = $scope.topOppList[defaultIndex].value;
    $scope.topOppDropdownModel = $scope.topOppList[defaultIndex];
  };
  $scope.onChangeRowsToDisplay = function () {
    $scope.topOppRowsToDisplay = $scope.topOppDropdownModel.value;
    romSummaryTopOppGridService.setMaxOpps($scope.topOppRowsToDisplay);
    $scope.$broadcast('grid:loadData:rom-summary-top-spill');
    $scope.$broadcast('grid:loadData:rom-summary-top-recap');
  };
  $scope.topOppGrids = {
    'rom-summary-top-spill': {
      title: 'Top Spill Revenue Gaps',
      data: undefined,
      selectedRows: undefined
    },
    'rom-summary-top-recap': {
      title: 'Top Recapture Revenue Gaps',
      data: undefined,
      selectedRows: undefined
    }
  };
  $scope.setDefaultState();
  $scope.topSpillContextMenuItems = [{
    caption: 'Market Analysis',
    event: 'context-menu:top-spill-opp-market-analysis'
  }];
  $scope.topRecapContextMenuItems = [{
    caption: 'Market Analysis',
    event: 'context-menu:top-recap-opp-market-analysis'
  }];
  $scope.$on('context-menu:top-spill-opp-market-analysis', goToRomAnalysis);
  $scope.$on('context-menu:top-recap-opp-market-analysis', goToRomAnalysis);
  $scope.$on('grid:rowSelectionChanged', function (event, selectedRows, gridId, allRows) {
    $scope.topOppGrids[gridId].data = allRows;
    $scope.topOppGrids[gridId].selectedRows = selectedRows;
  });
  $scope.getLastOptWeek = function (aggregated) {
    $scope.lastOptWeek = rmMomentFormat(momentService.of(aggregated.week, momentService.FIELD.OPT_GROUP_DATE), 'MONTH_DAY_YEAR');
    return aggregated.data;
  };
  function goToRomAnalysis(event) {
    var gridId = event.name === 'context-menu:top-spill-opp-market-analysis' ? 'rom-summary-top-spill' : 'rom-summary-top-recap';
    $state.go('app.rom-analysis', {
      transitionData: {
        timestamp: momentService.now(momentService.FIELD.EVENT_TIME_STAMP),
        searchCriteria: transitionSearchCriteriaService.romSummaryToAnalysis($scope.topOppGrids[gridId].selectedRows[0]),
        topOppGrid: {
          gridId: gridId,
          title: $scope.topOppGrids[gridId].title,
          data: $scope.topOppGrids[gridId].data,
          selectedRows: $scope.topOppGrids[gridId].selectedRows
        }
      }
    });
    window.scrollTo(0, 0);
  }
  $scope.$on('search-criteria:searchChangeEvent', function () {
    $scope.setDefaultState();
    $scope.onChangeRowsToDisplay();
  });
};
RomSummaryTopOppController.$inject = ['SearchCriteriaRuleFactory', 'MomentService', 'RomSummaryTopOppGridService', 'FeatureToggleService', '$scope', '$state', '$filter', 'TransitionSearchCriteriaService'];
module.exports = RomSummaryTopOppController;